import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
export const orderTicketRequestValidatorSchema = {
    id: Validator.optional(nonEmptyStringValidator),
    ticketTypeId: nonEmptyStringValidator,
    rewardId: Validator.optional(Validator.number({ min: 0 })),
    ticketRedemptionCardId: Validator.optional(nonEmptyStringValidator),
    voucherId: Validator.optional(nonEmptyStringValidator)
};
export const orderTicketRequestValidator = Validator.object(orderTicketRequestValidatorSchema);
